import Hls from "hls.js";

interface HlsCallbacks {
    onTracksReady: (languages: string[], subtitles: string[]) => void;
    onFatalError: () => void;
}

export const createHlsInstance = (
    video: HTMLVideoElement,
    url: string,
    isLiveContent: boolean,
    callbacks: HlsCallbacks
): Hls => {
    const hls = new Hls({
        debug: false,
        enableWorker: true,
        lowLatencyMode: true,
        startLevel: -1,
        maxBufferLength: isLiveContent ? 20 : 30,
        maxMaxBufferLength: isLiveContent ? 40 : 60,
        maxBufferSize: 60 * 1000 * 1000,
        maxBufferHole: 0.5,
        startPosition: -1,
        manifestLoadingMaxRetry: 5,
        levelLoadingMaxRetry: 5,
        fragLoadingMaxRetry: 5,
        liveSyncDurationCount: isLiveContent ? 2 : 3,
    });

    hls.attachMedia(video);
    hls.loadSource(url);

    hls.on(Hls.Events.MANIFEST_PARSED, (_event, data) => {
        const languages = (data.audioTracks ?? []).map((t: any) => t.name as string);
        const subtitles = (data.subtitleTracks ?? []).map((t: any) => t.name as string);
        callbacks.onTracksReady(
            Array.from(new Set(languages)),
            Array.from(new Set(subtitles))
        );
    });

    hls.on(Hls.Events.ERROR, (_event, data) => {
        if (!data.fatal) return;
        switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
                hls.startLoad();
                break;
            case Hls.ErrorTypes.MEDIA_ERROR:
                hls.recoverMediaError();
                break;
            default:
                callbacks.onFatalError();
                break;
        }
    });

    return hls;
};
